<template>
  <div style="display:flex; width:100%">
    <div
      class="p-1 border border-left-0 border-dark"
      style="height:auto; width:24%"
    >
      {{ name }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center"
      style="height:auto;width:5.3%"
    >
      {{ indicator.a }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center"
      style="height:auto;width:5.3%"
    >
      {{ indicator.b }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center"
      style="height:auto;width:5.3%"
    >
      {{ indicator.c }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center text-bold"
      style="height:auto; width: 7.4%; background-color:#dee2e6"
    >
      {{ subtotal }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center"
      style="height:auto; width:7.4%"
    >
      {{ bobot }}%
    </div>
    <div
      class="p-1 border border-left-0 border-dark col-nohover text-center"
      style="height:auto; width: 8.5%"
    >
      {{ new_actual }}%
    </div>
    <div
      class="p-1 border border-left-0 border-dark text-center text-bold align-bottom"
      style="height:auto; width: 15.8%"
    >
      {{ total }}
    </div>
    <div
      class="p-1 border border-left-0 border-dark text-center"
      style="height:auto;width:21%"
    >
      {{ note }}
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'subtotal',
    'name',
    'indicator',
    'bobot',
    'note',
    'new_actual',
    'max_value',
  ],
  computed: {
    total() {
      let subtotal = this.subtotal != 'N/A' ? Number(this.subtotal) : 0
      let max_value = Number(this.max_value)
      let indicator = Number(this.indicator.c)
      let bobot = this.new_actual ? Number(this.new_actual) : Number(this.bobot)
      console.log(
        '🚀 ~ file: tableDetailPenilaian.vue ~ line 76 ~ total ~ bobot',
        bobot,
        indicator,
        subtotal,
        max_value
      )

      let total = (max_value * (subtotal / indicator) * bobot) / 100
      return total.toFixed(2)
    },
    actual() {
      return this.bobot
    },
  },
}
</script>
